export const REVIEW_DECISIONS = {
  CONFIRMED: '已人工核对',
  NEEDS_REVIEW: '仍需复核',
  REJECTED: '提取有误',
  OUTDATED: '信息已过期',
  DUPLICATE: '重复标签',
};
const id = (value, zero = false) =>
  typeof value === 'string' &&
  (zero ? /^(0|[1-9][0-9]{0,18})$/ : /^[1-9][0-9]{0,18}$/).test(value) &&
  (value.length < 19 || value <= '9223372036854775807');
const less = (a, b) => a.length < b.length || (a.length === b.length && a < b);
const text = (value) =>
  typeof value === 'string' &&
  value.trim().length > 0 &&
  value.length <= 500 &&
  Array.from(value).every((char) => {
    const code = char.charCodeAt(0);
    return code >= 32 && (code < 127 || code > 159);
  });
export function readMemberTagReview(
  response,
  memberId,
  observationId,
  requestId,
) {
  const d = response?.data;
  if (
    !['00000', '0'].includes(String(response?.code)) ||
    String(d?.memberId) !== String(memberId) ||
    d?.observationId !== observationId ||
    !(
      requestId ? ['accepted', 'replayed'] : ['available', 'unavailable']
    ).includes(d?.outcome)
  )
    throw new Error('Invalid review scope');
  if (d.outcome === 'unavailable')
    return { memberId: d.memberId, observationId, outcome: d.outcome };
  if (
    typeof d.sourceHash !== 'string' ||
    !/^[a-f0-9]{64}$/.test(d.sourceHash) ||
    !id(d.latestReviewId, true) ||
    !Array.isArray(d.history) ||
    d.history.length > 10 ||
    typeof d.hasMore !== 'boolean' ||
    (d.hasMore && d.history.length !== 10)
  )
    throw new Error('Invalid review data');
  if (
    requestId &&
    (d.requestId !== requestId ||
      !id(d.acknowledgedReviewId) ||
      less(d.latestReviewId, d.acknowledgedReviewId))
  )
    throw new Error('Invalid review receipt');
  let before;
  d.history.forEach((row) => {
    if (
      !id(row?.reviewId) ||
      (before && !less(row.reviewId, before)) ||
      !Object.prototype.hasOwnProperty.call(REVIEW_DECISIONS, row.decision) ||
      !text(row.reason) ||
      typeof row.stale !== 'boolean' ||
      !Number.isSafeInteger(row.reviewedAt) ||
      row.reviewedAt <= 0 ||
      row.reviewedAt > 8640000000000000 ||
      (row.decision === 'DUPLICATE'
        ? typeof row.relatedObservationId !== 'string' ||
          !/^[A-Za-z0-9_-]{1,64}$/.test(row.relatedObservationId) ||
          row.relatedObservationId === observationId
        : row.relatedObservationId != null)
    )
      throw new Error('Invalid review history');
    before = row.reviewId;
  });
  if ((d.history[0]?.reviewId || '0') !== d.latestReviewId)
    throw new Error('Invalid review version');
  return d;
}
export const validReviewReason = text;
